export default [
  {
    path: "/data-crud",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/data-crud",
        name: "data-crud",
        component: () => import("./TablesDashboard.vue"),
      },
    ],
  },
  {
    path: "/table-crud",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/table-crud",
        name: "table-crud",
        component: () => import("./TableCrud.vue"),
      },
    ],
  },
  {
    path: "/report-builder",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/report-builder",
        name: "report-builder",
        //component: () => import("./BudgetManager.vue"),
        component: () => import("./ReportBuilder.vue"),
      },
    ],
  },
];
